import { all } from 'redux-saga/effects';

import consultarProcesso from './consultarProcesso/saga';
import consultarCin from './consultarCin/saga';
import consultarCinPPT from './consultarCinPPT/saga';
import consultarCpfCinResponsavel from './consultarCpfCinResponsavel/saga';

export default all([
	consultarProcesso,
	consultarCin,
	consultarCinPPT,
	consultarCpfCinResponsavel,
]);
